"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = Modal;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _ModalHeader = require("./ModalHeader/ModalHeader");

var _ModalContent = require("./ModalContent/ModalContent");

var _ModalControls = require("./ModalControls/ModalControls");

var _excluded = ["allowHeightOverflow", "position", "shouldCloseOnEscapePress", "shouldCloseOnOverlayClick", "size", "testId", "topOffset"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  "Modal__portal": "Modal__Modal__portal___1AjJC",
  "Modal__overlay": "Modal__Modal__overlay___3gPyC",
  "Modal__overlay--after-open": "Modal__Modal__overlay--after-open___sRqhJ",
  "Modal__overlay--before-close": "Modal__Modal__overlay--before-close___3hzWL",
  "Modal__overlay--centered": "Modal__Modal__overlay--centered___2kDOU",
  "Modal__wrap": "Modal__Modal__wrap___BjfRz",
  "Modal__wrap--zen": "Modal__Modal__wrap--zen___32JOV",
  "Modal__wrap--after-open": "Modal__Modal__wrap--after-open___1XDbx",
  "Modal": "Modal__Modal___2S_pS",
  "Modal__wrap--before-close": "Modal__Modal__wrap--before-close___1jI3B",
  "Modal--overflow": "Modal__Modal--overflow___2FUtB",
  "Modal--zen": "Modal__Modal--zen___2t2w9"
};
var ModalSizesMapper = {
  medium: '520px',
  small: '400px',
  large: '700px',
  fullWidth: '100vw',
  zen: '100vw'
};

function Modal(_ref) {
  var _cn2, _cn3;

  var allowHeightOverflow = _ref.allowHeightOverflow,
      position = _ref.position,
      shouldCloseOnEscapePress = _ref.shouldCloseOnEscapePress,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      size = _ref.size,
      testId = _ref.testId,
      topOffset = _ref.topOffset,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var allProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    allowHeightOverflow: allowHeightOverflow,
    position: position,
    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    size: size,
    testId: testId,
    topOffset: topOffset
  });

  var renderDefault = function renderDefault() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, otherProps.title && /*#__PURE__*/_react["default"].createElement(_ModalHeader.ModalHeader, (0, _extends2["default"])({
      title: otherProps.title,
      onClose: otherProps.onClose
    }, otherProps.modalHeaderProps)), /*#__PURE__*/_react["default"].createElement(_ModalContent.ModalContent, otherProps.modalContentProps, otherProps.children));
  };

  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    ariaHideApp: false,
    onRequestClose: otherProps.onClose,
    isOpen: otherProps.isShown,
    onAfterOpen: otherProps.onAfterOpen,
    shouldCloseOnEsc: shouldCloseOnEscapePress,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    portalClassName: styles.Modal__portal,
    className: {
      base: (0, _classnames["default"])(styles.Modal__wrap, (0, _defineProperty2["default"])({}, styles['Modal__wrap--zen'], size === 'zen')),
      afterOpen: styles['Modal__wrap--after-open'],
      beforeClose: styles['Modal__wrap--before-close']
    },
    style: {
      content: {
        top: position === 'center' ? 0 : topOffset
      }
    },
    overlayClassName: {
      base: (0, _classnames["default"])((_cn2 = {}, (0, _defineProperty2["default"])(_cn2, styles.Modal__overlay, true), (0, _defineProperty2["default"])(_cn2, styles['Modal__overlay--centered'], position === 'center'), _cn2)),
      afterOpen: styles['Modal__overlay--after-open'],
      beforeClose: styles['Modal__overlay--before-close']
    },
    htmlOpenClassName: "Modal__html--open",
    bodyOpenClassName: "Modal__body--open",
    closeTimeoutMS: 300
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-test-id": testId,
    style: {
      width: ModalSizesMapper[size] || size
    },
    className: (0, _classnames["default"])(styles.Modal, otherProps.className, (_cn3 = {}, (0, _defineProperty2["default"])(_cn3, styles['Modal--overflow'], allowHeightOverflow), (0, _defineProperty2["default"])(_cn3, styles['Modal--zen'], size === 'zen'), _cn3))
  }, typeof otherProps.children === 'function' ? otherProps.children(allProps) : renderDefault()));
}

Modal.Header = _ModalHeader.ModalHeader;
Modal.Content = _ModalContent.ModalContent;
Modal.Controls = _ModalControls.ModalControls; // Use defaultProps instead of default values in the function to allow the
// Storybook to import and use these values

Modal.defaultProps = {
  allowHeightOverflow: false,
  position: 'center',
  shouldCloseOnEscapePress: true,
  shouldCloseOnOverlayClick: true,
  size: 'medium',
  testId: 'cf-ui-modal',
  topOffset: '50px'
};